import { render, staticRenderFns } from "./EventOverview.vue?vue&type=template&id=f3d1c2c4&"
import script from "./EventOverview.vue?vue&type=script&lang=ts&"
export * from "./EventOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports